import React from "react";
import "./userInfoBox.css";

const UserInfoBoxCard = ({ count = 9 }) => {
  return (
    <>
      {[...Array(count)].map((_, index) => (
        <div key={index} className="skeleton-card">
          <div className="skeleton-image"></div>
          <div className="skeleton-content">
            <div className="skeleton-line skeleton-title"></div>
            <div className="skeleton-line skeleton-subtitle"></div>
            <div className="skeleton-line skeleton-price"></div>
            <div className="skeleton-actions">
              <div className="skeleton-button"></div>
              <div className="skeleton-button skeleton-button-full"></div>
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

export default UserInfoBoxCard;

